/* @flow */
import AccountTransferDisabledModal from './AccountTransferDisabledModal.jsx';
import DepositModal from './DepositModal.jsx';
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import IdentityAdditionalVerificationModalContainer from 'payments/containers/IdentityAdditionalVerificationModalContainer.jsx';
import Activity from 'entities/Activity';
import React from 'react';
import { mountModal } from 'lib/modal';

type Props = {
  activity: Activity,
  className?: ?string,
  children: Function,
};

type State = {
  loading: boolean,
};

class ActivityDepositStarter extends React.Component {
  props: Props;

  state: State = {
    loading: false,
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  onClick = () => {
    this.setState({ loading: true });
    const onDone = () => this.setState({ loading: false });

    // Refresh the payment account, we really don't
    // want to get this wrong here and really want
    // the latest state of the account.
    PaymentAccountActions.load().then(account => {
      const needBasicVerifications = (
        account.needBasicVerification() ||
        account.needBankAccountVerification()
      );

      if (needBasicVerifications) {
        this.context.router.push({
          pathname: '/transactions/deposit/setup',
          query: { req: this.props.activity.id },
        });
        return;
      }

      // if the account transfers is disabled this means the user
      // need a verifications step that we do not support in V1.
      if (account.isTransferEnabled()) {
        mountModal(<DepositModal activity={this.props.activity} />, this);
      } else if (account.needAdditionalVerification()) {
        mountModal(<IdentityAdditionalVerificationModalContainer />, this);
      } else {
        mountModal(<AccountTransferDisabledModal />, this);
      }
    }).then(onDone, onDone);
  }

  render() {
    return this.props.children({
      start: this.onClick,
      loading: this.state.loading,
    });
  }
}

export default ActivityDepositStarter;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityDepositStarter.jsx